<template>
    <div id="content">
        <div class="container-fluid page-title">
            <div class="container">
                <h1>
                    Contato
                </h1>
                <p class="info">Tire suas dúvidas e seja nosso Parceiro. Faremos bons negócios!</p>
            </div>
        </div>
        <div class="container pt-3">
            <form id="formContato" v-on:submit.prevent="sendMail">
                <div class="alert alert-info" v-if="enviandoEmail">
                    Aguarde...
                </div>
                <div class="alert alert-success" v-if="emailEnviado">
                    Email enviado. Logo entraremos em contato.
                </div>
                <div class="alert alert-danger" v-if="emailNaoEnviado">
                    Houve um problema ao enviar seu email, tente novamente.
                </div>
                <div class="form-row">

                    <div class="form-group col-md-4">
                        <label for="nome" class="required">Nome Completo:</label>
                        <input type="text" id="nome" name="nome" v-model="formContato.nome"
                               required="required"
                               class="form-control">
                    </div>

                    <div class="form-group col-md-4">
                        <label for="email" class="required">Email:</label>
                        <input type="email" id="email" v-model="formContato.email" name="email"
                               required="required"
                               class="form-control">
                    </div>


                    <div class="form-group col-md-4">
                        <label for="telefone" class="required">Telefone:</label>
                        <input type="text" id="telefone" v-model="formContato.telefone" name="telefone"
                               required="required"
                               class="form-control">
                    </div>

                </div>

                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="assunto" class="required">Assunto:</label>
                        <input type="text" id="assunto" v-model="formContato.assunto" name="assunto" required="required"
                               class="form-control">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label for="mensagem" class="required">Mensagem:</label>
                        <textarea rows="5" class="form-control" v-model="formContato.mensagem" name="mensagem"
                                  id="mensagem" required></textarea>
                    </div>
                </div>
                <div class="form-group col-md-12 text-center">
                    <button type="submit" class="btn btn-lg btn-danger">Enviar
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        data: () => ({
            formContato: {
                nome: null,
                email: null,
                telefone: null,
                assunto: null,
                mensagem: null,
                errors: [],
            },
            emailEnviado: false,
            emailNaoEnviado: false,
            enviandoEmail: false,
        }),
        methods: {
            sendMail() {
                this.enviandoEmail = true;
                axios.post('/contato', this.formContato)
                    .then(response => {
                        if (response.data.status) {
                            this.emailEnviado = true;
                            this.enviandoEmail = false;
                            document.getElementById("formContato").reset();
                        } else {
                            this.emailNaoEnviado = true;
                            this.enviandoEmail = false;
                        }
                    })
                    .catch(e => {
                        this.emailNaoEnviado = true;
                        this.enviandoEmail = false;
                        this.errors.push(e)
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Contato.vue?1333cabc